import { DateTime } from 'luxon';

/*
 * "My Events" operational window ends at the next 4 AM (browser-local): events
 * that start after this are hidden. Shared by the list, its stats and the
 * upcoming tooltip so all three agree.
 */
const MY_EVENTS_LATE_HOUR = 4;

export const myEventsCutoff = (): DateTime => {
  const now = DateTime.local();
  const fourAm = now.set({ hour: MY_EVENTS_LATE_HOUR, minute: 0, second: 0, millisecond: 0 });

  return now.hour < MY_EVENTS_LATE_HOUR ? fourAm : fourAm.plus({ days: 1 });
};
